import "./navbartranslation.css"
import React from 'react'
import TranslationContext from '../../../contexts/TranslationContext'
import { TemplateRow } from '../templaterow/TemplateRow'
import { Nav } from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { ArrowBack} from "@mui/icons-material"
import { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css'
import StatusContext from '../../../contexts/StatusContext'
import AuthContext from '../../../contexts/AuthContext'
import { SaveChat } from '../savechat/SaveChat'
import {PushButton} from '../pushbutton/PushButton'
import CircularProgress from '@mui/material/CircularProgress';
import {LoginDialog} from '../logindialog/LoginDialog'


export const NavBarTranslation = ({ title }) => {
  const [expanded, setExpanded] = useState(false);

  let {
    chatName,
    setChatName,
    setChatNames,
    chatNames,
    onSave,
    deleteChat,
    displayChat,
    promptsandresponses,

  } = React.useContext(TranslationContext);

  let {
    isLoading,
    statusNavbar,
    setStatusNavbar,
    changeLanguage,
    getChats,
    setShowLoginDialog,
  } = React.useContext(StatusContext);

  const {
    checkCurrentUser,
  } = React.useContext(AuthContext);
  

  const handleonArrowClick = () => {
    console.log("HandleOnArrowClick")
    setExpanded(!expanded)

  }
  const handleonClickNavBar = async () => {
    setStatusNavbar("");

    if (checkCurrentUser() === false)
      {
          setShowLoginDialog(true)
          return;
      }
    let chatsstatus = await getChats('translations')
    if (chatsstatus !== null)
      setChatNames(chatsstatus.chats)
    setExpanded(!expanded)
  }

  const handleSelect = () => {
    setExpanded(!expanded)
  }

  const onTemplateNameChange = (e) => {
    setChatName(e.target.value)
    if (e.target.value.length)
      setStatusNavbar("");
  }


  return (
    <Navbar expanded={expanded} key={false} bg="" expand={false} className="mb-2 py-0" sticky=''>
     
      {
          isLoading &&
            <div className='wait-icon'>
                <CircularProgress style={{ color: 'white' }}/>
            </div>
        }
      
        <div>
          <label className="navbarTitle">{changeLanguage('translation','navbartitle')}</label>
          <label className="navbarTemplateName"> {chatName} </label>
        </div>
        <div style = {{marginRight: '10px'}}>
          <PushButton onClick={handleonClickNavBar} label =  {changeLanguage('common','navbartopic')}/>
        </div>

        <Navbar.Offcanvas
          id={`offcanvasNavbar-expand-false`}
          aria-labelledby={`offcanvasNavbarLabel-expand-false`}
          placement="end"
         
        >
          <Offcanvas.Header onClick={handleSelect} >
            <Offcanvas.Title id={`offcanvasNavbarLabel-expand-false`}>
              <ArrowBack className="styleIconWithBackground" onClick={handleonArrowClick} />
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="justify-content-end flex-grow-1 pe-0">
            <label className="navbarTemplatesTitle">{changeLanguage('translation', 'navbarsavedtitles')}</label>
              <div className="navbarContainer">  
                <ul className="navbarNames">
                  {
                    Array.isArray(chatNames) &&
                    chatNames.map((chat) => (
                      <TemplateRow key={chat.id} chat={chat} deleteHandler={deleteChat} clickHandler={displayChat} setExpand={handleSelect} setTemplateName={setChatName} />
                    ))
                  }
                </ul>
              </div>

              <br></br>
              <SaveChat label="Topic name" text={chatName} disabled={promptsandresponses===null || promptsandresponses.length === 0} onChange={onTemplateNameChange} onSave={onSave}/>
             
              {
                (statusNavbar) &&
                    <div className='statusLabel'><label>{statusNavbar}</label></div>
              }
              <br></br>


              <div className='navbarFonts'>
                
                {changeLanguage('translation', 'navbartext1')}
                <br></br>
                <br></br>
                 {changeLanguage('translation', 'navbartext2')}
                <br></br>
                <br></br>
                 {changeLanguage('translation', 'navbartext3')}
              </div>

            </Nav>
          
             <LoginDialog />
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      
    </Navbar>
  );
}

export default NavBarTranslation;